import { createContext, useContext } from 'react'

import { SnackbarCtx } from './snackbar.types.ts'

export const SNACKBAR_TIMEOUT = 1000
export const MAX_SNACKS = 5
export const SnackbarContext = createContext<SnackbarCtx | null>(null)

export const useSnackbarContext = () => {
  const ctx = useContext(SnackbarContext)

  if (!ctx) {
    throw new Error('useSnackbar must be used within <SnackbarProvider/>')
  }

  return ctx
}
